export enum MutationTypes {
    SET_COMPANIES_LIST = "setCompaniesList",
    SET_COMPANIES_LIST_PAGE = "setCompaniesListPage",
    SET_COMPANIES_TOTAL = "setCompaniesTotal",
    SET_COMPANIES_LIST_PER_PAGE = "setCompaniesListPerPage",
    SET_COMPANIES_DATA_IS_LOADING = "setCompaniesDataIsLoading",
    SET_COMPANIES_SORT_VALUE = "setCompaniesSortValue",
    SET_COMPANIES_FILTER_VALUE = "setCompaniesFilterValue",
    SET_COMPANIES_SELECTED_COMPANY = "setCompaniesSelectedCompany"
}